import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import SalesTaxesDataTable from "./SalesTaxesDataTable";
import moment from "moment";
import frLocale from "moment/locale/fr";
import { SALES_TAXES } from "../../../utils/data/models";
import * as salesTaxesActions from "./salesTaxesActions";

class SalesTaxesFields extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      rateTypes: [
        { name: "salesTaxes.types.hst", key: "tpsTvh" },
        { name: "salesTaxes.types.pst", key: "tvpTvq" },
        { name: "salesTaxes.types.insurance", key: "insurance" },
      ],
    };
    moment.locale(props.locale.split("-")[0], [frLocale]);
    this.getData = this.getData.bind(this);
    this.saveSalesTaxes = this.saveSalesTaxes.bind(this);
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
    return this.props.salesTaxesActions.getTaxes(
      SALES_TAXES,
      0,
      0,
      "",
      ["order:asc", "provinceCode:asc"],
      []
    );
  }

  formatDate(date) {
    /**
     * This function returns formatted date in "MMMM Do YYYY" format
     * Return types:
     * date string
     */
    return moment(date).format("MMMM Do YYYY");
  }

  isCurrentPeriod(startDate, endDate) {
    /**
     * This function returns if the given period is current period or not
     * Return types:
     * boolean
     */
    let today = new Date().toISOString().substring(0,10); // Removing time from date
    return moment(today).isSameOrAfter(startDate) &&
      moment(today).isSameOrBefore(endDate)
      ? true
      : false;
  }

  getPeriods(dateObj) {
    /**
     * This function returns the string format for readable data for periods
     * Return types:
     * isCurrentPeriod: boolean
     * date : string
     */
    const start = this.formatDate(dateObj.startDate);
    let end;
    dateObj.endDate ? (end = dateObj.endDate) : new Date().toISOString();
    const isCurrentPeriod = this.isCurrentPeriod(dateObj.startDate, end);
    end = this.formatDate(end);
    const date = `${start} - ${end}`;
    return { isCurrentPeriod: isCurrentPeriod, date: date };
  }

  getInitialValues() {
    /**
     * This function returns the initializing values for page salesTaxesDataTable
     * Return types:
     * initialValues: dict
     * provinces : list
     * taxesWithPeriod : dict
     */
    let initialValues = {};
    let provinces = [];
    let taxesWithPeriod = {};
    this.props.items.map((province) => {
      const provinceCode = province.provinceCode.replace("CA-", "");
      !provinces.includes(provinceCode) && provinces.push(provinceCode);
      const dateDict = {
        startDate: province.startDate,
        endDate: province.endDate,
      };
      const period = this.getPeriods(dateDict);
      let value = province["salesTaxId"];
      const isExisting = provinceCode in taxesWithPeriod;
      !isExisting && (taxesWithPeriod[provinceCode] = []);
      taxesWithPeriod[provinceCode] = [
        ...taxesWithPeriod[provinceCode],
        { text: period["date"], value: value },
      ];
      const isCurrentPeriod = period["isCurrentPeriod"];
      if (isCurrentPeriod) {
        this.state.rateTypes.map((type) => {
          initialValues[provinceCode + type.key] = province[type.key] || 0;
        });
        initialValues["current" + provinceCode] = value;
      }
    });
    return {
      initialValues: initialValues,
      provinces: provinces,
      taxesWithPeriod: taxesWithPeriod,
    };
  }

  saveSalesTaxes(values) {
    let taxes = [...this.props.items];
    taxes.map((province) => {
      const provinceCode = province.provinceCode.replace("CA-", "");
      const startDate = province.startDate;
      let endDate;
      endDate = province.endDate
        ? (endDate = province.endDate)
        : new Date().toISOString();
      const isCurrentPeriod = this.isCurrentPeriod(
        startDate,
        endDate
      );
      isCurrentPeriod &&
        this.state.rateTypes.map((type) => {
          province[type.key] = values[provinceCode + type.key] || 0;
        });
    });
    this.props.salesTaxesActions.updateTaxes(SALES_TAXES, taxes).then(() => {
      this.getData();
    });
  }

  render() {
    const values = this.getInitialValues();
    const initialValues = values["initialValues"];
    const provinces = values["provinces"];
    const options = values["taxesWithPeriod"];
    return (
      <div>
        {this.props.items.length > 0 && (
          <SalesTaxesDataTable
            ref="taxForm"
            onSubmit={this.saveSalesTaxes}
            options={options}
            initialValues={initialValues}
            rows={provinces}
            taxes={this.state.rateTypes}
          />
        )}
      </div>
    );
  }
}

SalesTaxesFields.propTypes = {
  items: PropTypes.array,
  salesTaxesActions: PropTypes.object,
  locale: PropTypes.string,
};

function mapStateToProps(state) {
  const data = state.taxes || {};
  return {
    items: data.items || [],
    locale: state.auth.user.languageCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesTaxesActions: bindActionCreators(salesTaxesActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesTaxesFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/SalesTaxesFields.js